import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  sm: {
    fontWeight: 300,
    fontSize: 14,
    lineHeight: "20px",
  },
  md: {
    fontWeight: 300,
    fontSize: 16,
    lineHeight: "24px",
  },
  lg: {
    fontWeight: 300,
    fontSize: 18,
    lineHeight: "28px",
  },
}));
